import { render, staticRenderFns } from "./startChatPlaceholder.vue?vue&type=template&id=5af58932&"
import script from "./startChatPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./startChatPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports